import { render, staticRenderFns } from "./cocurrentAndConvection.vue?vue&type=template&id=5e476355&"
import script from "./cocurrentAndConvection.vue?vue&type=script&lang=js&"
export * from "./cocurrentAndConvection.vue?vue&type=script&lang=js&"
import style0 from "./cocurrentAndConvection.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports